import React from "react";

function About() {
  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "40px auto",
        padding: "20px",
        fontFamily: "'Nunito', sans-serif",
      }}
    >
      <h2>About Share Your Kofi</h2>

      <p style={{ fontSize: "0.95rem", color: "#555", lineHeight: "1.6" }}>
        💡 Idea sparked: <strong>Thursday, 24 April 2025</strong>
        <br />
        💻 Coded: <strong>Friday, 25 April 2025</strong>
        <br />
        🚀 Launched: <strong>Saturday, 26 April 2025</strong>
      </p>

      <div
        style={{ textAlign: "left", marginTop: "20px", marginBottom: "20px" }}
      >
        <img
          src="/SYK_logo.png"
          alt="Share Your Kofi Logo"
          style={{ width: "100px", height: "100px", objectFit: "contain" }}
        />
      </div>

      <p style={{ fontSize: "1rem", color: "#444", lineHeight: "1.6" }}>
        Share Your Kofi is a simple and free platform that helps creators on
        Ko-fi get discovered. Whether you're a digital artist, writer,
        podcaster, or someone with a passion project, this site lets you
        showcase your Ko-fi profile to new audiences.
      </p>
      <p style={{ fontSize: "1rem", color: "#444", lineHeight: "1.6" }}>
        Fans can also recommend their favorite creators to help them shine.
        Every submission is featured in our public directory - no logins, no
        fuss. This project is independently built by a fellow Ko-fi user who
        simply loves helping others get seen.
      </p>
      <p style={{ fontSize: "1rem", color: "#444", lineHeight: "1.6" }}>
      All creator listings on this site are submitted by the creators themselves or recommended by others. 
      Share Your Kofi does not vet or endorse any listings, and is not responsible for the content, accuracy, or services offered by any creator. 
      Please do your own due diligence before engaging or purchasing from any page.
      </p>
      <hr style={{ margin: "40px 0" }} />

      <div
        style={{ textAlign: "left", marginTop: "20px", marginBottom: "20px" }}
      >
        <img
          src="/ManojPolaroidBio.png"
          alt="Share Your Kofi Logo"
          style={{ width: "100px", height: "100px", objectFit: "contain" }}
        />
      </div>

      <h3>About the Creator</h3>
      <p style={{ fontSize: "1rem", color: "#444", lineHeight: "1.6" }}>
        Hi, I’m Manoj from Sydney, Australia. I enjoy building simple online
        tools, giving creative ideas a home, and helping others get noticed
        online. I also spend time drawing, coding, blogging recipes, making
        stickers, and exploring Australia for my vlog and podcast. You can check
        out all my ventures here:{" "}
        <a
          href="https://emanoj.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#4dabf7",
            textDecoration: "underline",
            marginLeft: "5px",
          }}
        >
          emanoj.com
        </a>
      </p>

      <p style={{ fontSize: "1rem", color: "#444", lineHeight: "1.6" }}>
        I'm a big fan of Ko-fi -
        <a
          href="https://ko-fi.com/emanoj"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#4dabf7",
            textDecoration: "underline",
            marginLeft: "5px",
          }}
        >
          I use it myself
        </a>{" "}
        and absolutely love how visually appealing, easy to use, and
        feature-rich it is. But while I enjoyed building my own page, I found it
        surprisingly hard to discover other creators. The official Ko-fi
        platform didn’t have a public directory or marketplace, and finding
        creators felt like pure chance through web searches or social posts.
      </p>

      <p style={{ fontSize: "1rem", color: "#444", lineHeight: "1.6" }}>
        That’s when the lightbulb moment hit! I thought - I know how to code, I
        love Ko-fi and its amazing creator community - maybe I can bring
        everyone together. So I spent a weekend building this project... and
        here it is: <strong>Share Your Kofi</strong>.
      </p>

      <p style={{ fontSize: "1rem", color: "#444", marginTop: "20px" }}>
        Thanks for visiting - I hope you discover some amazing creators today!
      </p>

      <p style={{ fontSize: "0.9rem", color: "#666", marginTop: "20px" }}>
        Got feedback or ideas? Feel free to
        <a
          href="https://ko-fi.com/emanoj"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#4dabf7",
            textDecoration: "underline",
            marginLeft: "5px",
          }}
        >
          message me on Ko-fi
        </a>{" "}
        or
        <a
          href="https://tally.so/r/w8qkjP"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#4dabf7",
            textDecoration: "underline",
            marginLeft: "5px",
          }}
        >
          fill out this contact form
        </a>
        .
      </p>
      <hr style={{ margin: "40px 0" }} />

      <h3>Support This Project</h3>

      <p style={{ fontSize: "0.95rem", color: "#444", lineHeight: "1.6" }}>
        This site is created, coded, and maintained entirely by me. It takes
        time to keep it running smoothly, and a bit of money too (domain, server
        & database fees, etc). If you’d like to support this project in any way
        - a small tip would mean the world. Thank you so much in advance!
      </p>

      <iframe
        id="kofiframe"
        src="https://ko-fi.com/emanoj/?hidefeed=true&widget=true&embed=true&preview=true"
        style={{
          border: "none",
          width: "100%",
          padding: "4px",
          background: "#f9f9f9",
          borderRadius: "8px",
        }}
        height="712"
        title="emanoj donation widget"
      />
    </div>
  );
}

export default About;
